import api from './api';

export const getHelp = async () => {
  const response = await api.get('/help');
  return response.data;
};

export const updateHelp = async (content) => {
  const response = await api.put('/help/admin', { content });
  return response.data;
};
